module.exports = __webpack_public_path__ + "static/media/freshdesk-logo.3e95ec0d.webp";